module.exports = __webpack_public_path__ + "img/icon-actions-edit.2f3e7287.svg";